export default [
  //Set DXm
  {
    name: 'dxm',
    type: 'gltfModel',
    path: 'models/dxm.glb',
  },
  //floor
  {
    name: 'marbleColor',
    type: 'texture',
    path: 'textures/marble-color.jpg',
  },
  {
    name: 'marbleNormal',
    type: 'texture',
    path: 'textures/marble-normal.jpg',
  },
  {
    name: 'marbleRoughness',
    type: 'texture',
    path: 'textures/marble-roughness.jpg',
  },
  //screens
  {
    name: 'turtle',
    type: 'texture',
    path: 'textures/turtle.jpg',
  },
  {
    name: 'car',
    type: 'texture',
    path: 'textures/car.jpg',
  },
  {
    name: 'shoe',
    type: 'texture',
    path: 'textures/shoe.jpg',
  },
  //stand
  {
    name: 'stand',
    type: 'texture',
    path: 'textures/stand.jpg',
  },
  {
    name: 'home',
    type: 'texture',
    path: 'img/dxm.png',
  },
]
